"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Label.css");
var LabelStylesMaps_1 = require("./LabelStylesMaps");
var accessibility_1 = require("../../../utils/accessibility");
var XSS_1 = require("../../../utils/XSS");
var Label = /** @class */ (function (_super) {
    __extends(Label, _super);
    function Label(props) {
        return _super.call(this, props) || this;
    }
    Label.prototype.render = function () {
        var val = XSS_1.default.validContent(this.props.data.text, this.props.data.isDecodingRequired, Label.allowedTags);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: this.getCssClasses() },
                (this.props.options.accessibility) &&
                    React.createElement("span", __assign({ className: "" + styles.hiddenSpoken, "aria-hidden": "false", dangerouslySetInnerHTML: { __html: this.ariaLabelContent } }, (this.props.options && this.props.options.arialabelledby)
                        ? { id: this.props.options.arialabelledby } : {}, { tabIndex: (this.props.options && this.props.options.tabIndex) ? 0 : null })),
                React.createElement("span", __assign({ "data-test-id": this.props.testId }, (this.props.options && this.props.options.accessibility)
                    ? { 'aria-hidden': true } : {}, { dangerouslySetInnerHTML: { __html: val } }, (this.props.options) ? accessibility_1.getAccessibilityAttributes(this.props.options) : {})),
                (this.props.children) &&
                    React.createElement("span", __assign({}, this.props.options ? accessibility_1.getAccessibilityAttributes(this.props.options) : {}), this.props.children))));
    };
    Label.prototype.getSizeFromOps = function (options) {
        if (!options || !options.size || !LabelStylesMaps_1.stylesMap.has(options.size)) {
            return styles.medium;
        }
        return LabelStylesMaps_1.stylesMap.get(options.size);
    };
    Label.prototype.getTypeFromOps = function (options) {
        if (options && options.type) {
            var type = LabelStylesMaps_1.typesMap.get(options.type);
            return type ? type : undefined;
        }
    };
    Label.prototype.getCssClasses = function () {
        var cssClasses = [
            this.props.options.className,
            this.getSizeFromOps(this.props.options),
            this.getTypeFromOps(this.props.options),
        ];
        cssClasses.push(styles.labelParent);
        if (this.props.options.prefix) {
            cssClasses.push(styles.prefix);
        }
        return cssClasses.join(' ');
    };
    Object.defineProperty(Label.prototype, "ariaLabelContent", {
        get: function () {
            if (this.props.options.accessibility) {
                return this.props.options.accessibility;
            }
            return this.props.data.text;
        },
        enumerable: false,
        configurable: true
    });
    Label.allowedTags = {
        A: ['href', 'id', 'class', 'target', 'onclick'],
        B: ['role'],
        BR: [],
        DIV: ['class', 'id', 'style'],
        H1: ['class', 'id'],
        H2: ['class', 'id'],
        H3: ['class', 'id'],
        H4: ['class', 'id'],
        H5: ['class', 'id'],
        H6: ['class', 'id'],
        I: ['role'],
        LI: [],
        P: ['class', 'id', 'role'],
        SPAN: ['class', 'id', 'role'],
        STRONG: [],
        SUB: [],
        SUP: [],
        U: [],
        UL: [],
    };
    Label.defaultProps = {
        options: {
            className: '',
        },
    };
    return Label;
}(React.Component));
exports.default = Label;
//# sourceMappingURL=Label.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Label/Label.js
// module id = 103
// module chunks = 8